import shortid from 'shortid'

export type ClonedActionDto = Omit<ActionDto, '_sid'> & { _new: true; _sid: null }

export function cloneAction(action: ActionDto): ClonedActionDto {
    const { _sid, ...prevAction } = action

    return {
        ...prevAction,
        _sid: null,
        _new: true,
        name: `${action.name} (2)`,
        options: {
            ...action.options,
            steps: action.options.steps.map((step) => ({
                ...step,
                id: `action_step_${shortid.generate()}`,
            })),
        },
    }
}
